import React from "react";
import { Form, Icon, Input } from "antd";

const { Item } = Form;

const PasswordFormItem = ({
  message,
  fieldName,
  placeHolder,
  autoComplete,
  getFieldDecorator,
}) => (
  <Item>
    {getFieldDecorator(fieldName, {
      rules: [{ required: true, message }],
    })(
      <Input.Password
        placeholder={placeHolder}
        autoComplete={autoComplete}
        prefix={<Icon type="lock" className="form-input-icon" />}
      />
    )}
  </Item>
);

export default PasswordFormItem;
